export default "__VITE_ASSET__377c46df__"